import axios from 'axios';
export const GetTrades = () => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `trade/trade-assignment-tree`
  );
};

export const GetAllTrades = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `trade`);
};
export const getTradeAssignmentDetail = (trade_id: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL +
      `assignment/assignment-of-trade?where=` +
      trade_id
  );
};
export const GetAssignmentOfTheTrade = (trade_id: string) => {
  const query =
    process.env.REACT_APP_API_GLOBAL_URL + `assignment/assignment-of-trade?where=` + trade_id;
  return axios.get(query);
};
